import { Dropdown } from "react-bootstrap";
import SelectArrowIcon from "../../icons/select-arrow.icon";
import SuccessSignIcon from "../../icons/success-sign.icon";
import useDropdown from "../../../hooks/dropdown.hook";
import "./dropdown-sections-select.styles.scss";

const DropdownSectionsSelect = ({ 
  placeholder = '', 
  sections = [],
  onItemSelected = () => {}, 
  selected,
  className = '',
  dropDownMenuClass = '',
  itemMenuClass = '',
  fieldId,
  fieldValue,
}) => {
  const { isOpen, refBtn, refMenu, setIsOpen } = useDropdown({  });
  const curPlaceholder = selected || placeholder;

  return (
    <Dropdown
      show={isOpen} 
      onToggle={() => setIsOpen(prev => !prev)} 
      className={`transparennt-wrapper-dropdown dropdown-sections-select my-dropdown ${className}`}
    >
      <Dropdown.Toggle ref={refBtn}>
        <div className="toggle">
          <span>{selected ? curPlaceholder[fieldValue] : curPlaceholder}</span>
          <div>
            <SelectArrowIcon width="12px" height="9px" />
          </div>
        </div>
      </Dropdown.Toggle>
      {isOpen && (
        <Dropdown.Menu renderOnMount ref={refMenu} className={`menu disable-transform ${dropDownMenuClass}`}>
          {sections.map((section, index) => (
            <div key={`section-${section.title}-${index}`}>
              <h3 className="title my-0">
                {section.title}
              </h3>
              {section.list.map((item, index) => (
                <div className={`item ${itemMenuClass}`} key={index} onClick={() => {
                  onItemSelected(item);
                  setIsOpen(false);
                }}>
                  <SuccessSignIcon width={12} height={9} fill={selected && selected[fieldId] === item[fieldId] ? "#616778" : 'transparent'} />
                  <span>{item[fieldValue]}</span>
                </div>
              ))}
            </div>
          ))}
        </Dropdown.Menu>
      )}
    </Dropdown>
  );
}

export default DropdownSectionsSelect;
